import { useState } from "react";
import { X, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function SeederNewJobModal({
  onClose,
  onSubmit,
  isSubmitting,
}: {
  onClose: () => void;
  onSubmit: (niches: string[], adsPerBrand: number) => void;
  isSubmitting: boolean;
}) {
  const [nichesRaw, setNichesRaw] = useState("");
  const [adsPerBrand, setAdsPerBrand] = useState(10);

  const niches = nichesRaw
    .split("\n")
    .map((n) => n.trim())
    .filter((n) => n.length > 0);

  const canSubmit = niches.length > 0 && niches.length <= 10 && adsPerBrand >= 1 && adsPerBrand <= 30 && !isSubmitting;

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg max-w-lg w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">New Seed Job</h2>
          <button
            data-testid="button-close-new-job-modal"
            onClick={onClose}
            className="text-[#526074] hover:text-[#526074]"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">
            Niches (one per line, max 10)
          </label>
          <textarea
            data-testid="textarea-niches"
            value={nichesRaw}
            onChange={(e) => setNichesRaw(e.target.value)}
            rows={6}
            placeholder="SaaS for DTC brands&#10;Meal delivery&#10;Apparel DTC"
            className="w-full border border-[#DCE3ED] rounded px-3 py-2 text-sm font-mono"
          />
          <p className="text-xs text-[#526074] mt-1">{niches.length} niche(s) entered</p>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Ads per brand</label>
          <input
            data-testid="input-ads-per-brand"
            type="number"
            value={adsPerBrand}
            onChange={(e) => setAdsPerBrand(parseInt(e.target.value) || 10)}
            min={1}
            max={30}
            className="w-full border border-[#DCE3ED] rounded px-3 py-2 text-sm"
          />
          <p className="text-xs text-[#526074] mt-1">
            For each approved brand, the top N longest-running image ads get scraped. Default 10.
          </p>
        </div>

        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            data-testid="button-submit-new-job"
            onClick={() => onSubmit(niches, adsPerBrand)}
            disabled={!canSubmit}
          >
            {isSubmitting ? (
              <><Loader2 className="h-4 w-4 animate-spin mr-1" /> Creating...</>
            ) : (
              "Start Discovery"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
